import React, { PropsWithChildren } from "react";
import styles from "./colored-gradient-border-container.module.scss";

const cssClassName = "colored-gradient-border-container";

export const ColoredGradientBorderContainer = ({
  children,
}: PropsWithChildren) => {
  return <div className={styles[cssClassName]}>{children}</div>;
};
